import { Star } from "lucide-react";
import { Reveal } from "./Reveal";

const ITEMS = [
  {
    quote:
      "Troquei de provedor e o streaming parou de travar. Quando preciso de suporte, resolvem rapidinho pelo WhatsApp.",
    name: "Marina S.",
    place: "Jardim Vicente de Carvalho",
  },
  {
    quote:
      "Instalação foi rapidinha e a internet não cai mais à noite, quando todo mundo chega em casa.",
    name: "Carlos H.",
    place: "Centro",
  },
  {
    quote:
      "Jogo online toda noite e nunca mais tomei lag. A conexão aguenta meu setup inteiro ligado.",
    name: "Diego P.",
    place: "Jardim Vicente de Carvalho",
  },
];

export default function Testimonials() {
  return (
    <section
      id="depoimentos"
      data-testid="testimonials-section"
      className="scroll-mt-24 py-24 sm:py-32"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <p className="font-mono text-xs tracking-[0.35em] text-violet-400">
            / DEPOIMENTOS
          </p>
          <h2 className="mt-5 font-display text-4xl font-black tracking-tight sm:text-5xl lg:text-6xl">
            Quem usa, recomenda.
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {ITEMS.map((item, i) => (
            <Reveal key={item.name} delay={i * 0.12}>
              <figure className="flex h-full flex-col rounded-2xl border border-white/10 bg-surface p-8 transition-all duration-300 hover:-translate-y-1 hover:border-violet-600/40">
                <div className="flex gap-1" aria-label="5 de 5 estrelas">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star key={s} className="h-4 w-4 fill-violet-400 text-violet-400" />
                  ))}
                </div>
                <blockquote className="mt-6 flex-1 text-sm leading-relaxed text-white/70">
                  “{item.quote}”
                </blockquote>
                <figcaption className="mt-7 border-t border-white/10 pt-5">
                  <p className="font-display font-bold">{item.name}</p>
                  <p className="mt-1 font-mono text-xs text-white/40">{item.place}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
